import isNil from 'lodash/isNil';

/**
 * Normalizes line endings in a string to Unix line endings
 * @param input - The string to normalize
 * @returns The normalized string
 */
export function normalizeLineEndings(input: string | undefined) {
    if (isNil(input)) {
        return '';
    }
    return input
        .replace(/\r\n/g, '\n') // Convert Windows line endings to Unix
        .replace(/\r/g, '\n'); // Convert old Mac line endings to Unix
}
